import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { hexColorWithOpacityToString } from '~/_shared/components/colorPicker/colorPicker.helpers';
import type { Theme } from '~/_shared/themes/theme.model';

export const dropdownStyle = css({
  height: '100%',
});

export const listStyle = (theme: Theme) => css({
  background: theme.backgroundColors.quinary,
  border: `1px solid ${theme.borderColors.primary}`,
  borderRadius: 4,
  boxShadow: `0px 2px 15px ${theme.shadowColors.primary}`,
  marginTop: 1,
});

export const searchLabelStyle = css({
  display: 'block',
});

export const sortDropdownContainerStyle = css({
  '&:before': {
    display: 'none',
  },
});

export const listHeaderStyle = (theme: Theme) => css({
  alignItems: 'center',
  background: theme.backgroundColors.quaternary,
  color: theme.textColors.quaternary,
  display: 'flex',
  fontSize: 16,
  fontWeight: 'bold',
  height: 40,
  padding: '0 32px',
  textTransform: 'uppercase',
});

export const SecondaryListingItem = styled.div({
  overflow: 'hidden',
});

export const secondaryListingSpacer = css({
  height: 6,
});

export const listingItemStyle = (theme: Theme) => css({
  '&:nth-of-type(2n)': {
    [`${SecondaryListingItem}:nth-of-type(2n + 1)`]: {
      backgroundColor: hexColorWithOpacityToString(theme.backgroundColors.tertiary, .3),
      '&:hover': {
        backgroundColor: theme.backgroundColors.secondaryHover,
      },
    },
  },
  '&:nth-of-type(2n + 1)': {
    backgroundColor: hexColorWithOpacityToString(theme.backgroundColors.tertiary, .3),
    [`${SecondaryListingItem}:nth-of-type(2n+1)`]: {
      backgroundColor: theme.backgroundColors.quinary,
      '&:hover': {
        backgroundColor: theme.backgroundColors.secondaryHover,
      },
    },
  },
});

export const listingItemTriggerStyle = (theme: Theme) => css({
  display: 'flex',
  width: '100%',
  padding: '5px 0',
  justifyContent: 'space-between',
  overflowY: 'auto',

  '&:hover': {
    backgroundColor: theme.backgroundColors.secondaryHover,
  },
});

export const listingItemTitleStyle = (isHighlighted: boolean) => (theme: Theme) => css({
  color: isHighlighted ? theme.textColors.success : theme.textColors.primary,
  whiteSpace: 'nowrap',
  padding: 0,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  background: 'none',
  border: 'none',
  fontSize: '16px',
  lineHeight: '30px',
  textAlign: 'left',

  '&:hover': {
    color: isHighlighted ? theme.textColors.successOnHover : theme.textColors.linkOnHover,
  },
});

export const listingNumberStyle = (theme: Theme) => css({
  color: theme.textColors.secondary,
  fontSize: 14,
  fontWeight: 'normal',
  margin: '0 9px 0 26px',
  textTransform: 'uppercase',
});

export const listingItemIconStyle = (isHighlighted?: boolean) => (theme: Theme) => css({
  color: isHighlighted ? theme.iconColors.success : theme.iconColors.contrast,
  padding: 0,
  width: 32,
  textAlign: 'center',
  display: 'inline-block',
});

export const toggleButtonStyle = (theme: Theme) => css({
  padding: 0,
  width: 24,
  height: 30,
  lineHeight: '30px',
  fontSize: 14,
  background: 'none',
  color: theme.textColors.primary,
  border: 'none',
  margin: '0 2px 0 0',
});

export const toggleButtonIconStyle = ({ shouldRotate }: { shouldRotate: boolean }) => css({
  transition: 'transform .2s',
  transform: shouldRotate ? undefined : 'rotate(180deg)',
});

export const listingItemSecondaryTitleStyle = (isHighlighted?: boolean) => (theme: Theme) => css({
  display: 'inline-flex',
  margin: '10px 0 10px 26px',
  alignItems: 'center',
  color: isHighlighted ? theme.textColors.success : theme.textColors.primary,
  fontSize: '16px',
  lineHeight: 1.25,

  '&:hover': {
    color: isHighlighted ? theme.textColors.successOnHover : theme.textColors.linkOnHover,
  },
});

export const headerStyle = css({
  padding: 16,
});

export const spaceTopStyle = css({
  paddingTop: 10,
});

export const headerButtonsStyle = css({
  display: 'flex',
  justifyContent: 'end',
  width: '100%',
});

export const headerButtonStyle = css({
  marginLeft: 10,
});

export const loaderStyle = css({
  borderRadius: '0 0 4px 4px',
});

export const noResultsStyle = css({
  margin: 0,
  textAlign: 'center',
});
